import { render } from "./Selectable.vue?vue&type=template&id=288394a0"
import script from "./Selectable.vue?vue&type=script&lang=js"
export * from "./Selectable.vue?vue&type=script&lang=js"
script.render = render

export default script